import React, {Component} from 'react';
import {Modal, Radio, Toast} from 'antd-mobile';
import "./style.less";
import {walletBindinQguery} from "../../service/homeService";
const yinlian = require('../../common/image/yinlian.png');
export default class SelectBank extends Component {
    constructor(props) {
        super(props);
        this.state = {
            payVal:"",
            bankData:"",
        };
    }
    componentDidMount(){
        walletBindinQguery({source:1,token:this.props.userInfo.token,}).then((res)=>{
            if(res.data.code === '0000'){
                Toast.hide();
                this.setState({bankData:res.data.data,payVal:res.data.data[0].bankName});
                this.props.changeBank(res.data.data[0])
            }else{
                Toast.info(res.data.msg,3);
            }
        })
    }
    render(){
        return(
            <Modal
                popup
                className="bankModal"
                visible={this.props.modal}
                onClose={() => this.props.onClose()}
                maskClosable={false}
                animationType="slide-up"
            >
                <div className="warps">
                    <div className="tit">
                        <span>选择支付方式</span>
                        <i className="icon iconfont iconchacha" onClick={()=>this.props.onClose()}/>
                    </div>
                    <div className="con">
                        <div className="payBox">
                            {this.state.bankData && this.state.bankData.map((res, i) => (
                                <Radio className="my-radio" key={i} checked={this.state.payVal === res.bankName}
                                       onChange={() => {
                                           this.props.changeBank(res);
                                           this.setState({payVal: res.bankName})
                                       }}>
                                    <div className="box">
                                        <img src={yinlian} alt=""/>
                                        <p className="bottom">{res.bankName}({res.bankNumber.substring(res.bankNumber.length-4)})</p>
                                    </div>
                                </Radio>
                            ))}
                        </div>
                        {/*<div className="listBox">
                            <div>
                                <i className="icon iconfont iconwojiajia"/>
                                <span>添加新的银行卡</span>
                            </div>
                            <i className="icon iconfont icontiaozhuan2"/>
                        </div>*/}
                    </div>
                </div>

            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SelectBank/index.js